(function () {
  window.dataLayer = window.dataLayer || [];

  const push = (eventName, detail = {}) => {
    const payload = {
      event: eventName,
      ...detail,
    };

    window.dataLayer.push(payload);
    document.dispatchEvent(
      new CustomEvent('spillthat:tracking', {
        detail: payload,
      }),
    );
  };

  window.SpillThatTracking = {
    push,
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-track-event]');
    if (!trigger) return;

    push(trigger.dataset.trackEvent, {
      context: trigger.dataset.trackContext || null,
      label: trigger.dataset.trackLabel || trigger.textContent.trim(),
    });
  });
})();
